export const DEFAULT_ERROR_MESSAGE =
  'Some thing went wrong! Please contact our vendor.'

export const DEFAULT_INPUT_IS_REQUIRED = 'This input is required!'

export const RELATED_TO_OPTIONS = [
  { label: 'Event', value: 'event' },
  { label: 'Blog', value: 'blog' },
  { label: 'News', value: 'news' },
  { label: 'Exhibitor', value: 'exhibitor' },
]

export const CUSTOMER_TYPE = [
  { label: 'Visitor', value: 'visitor' },
  { label: 'Exhibitor', value: 'exhibitor' },
]

export const RELATED_TO_PARTICIPANT_OPTIONS = [
  { label: 'Volunteer', value: 'volunteer' },
  { label: 'Speaker', value: 'speaker' },
  { label: 'Sponsor', value: 'sponsor' },
  { label: 'Organizing Team', value: 'organizer' },
  { label: 'Media', value: 'media' },
]

export const RELATED_TO_INFORMATION_OPTIONS = [
  { label: 'FAQ', value: 'faq' },
  { label: 'About', value: 'about' },
  { label: 'Privacy Policy', value: 'privacy_policy' },
  { label: 'Terms & Conditions', value: 'terms_conditions' },
  { label: 'Contact Us', value: 'contact_us' },
]

export const SCANNER_GATE_OPTIONS = [
  { label: 'Main Gate', value: 'main_gate' },
  { label: 'HFS Gate', value: 'hfs_gate' },
  { label: 'Hub Gate', value: 'hub_gate' },
  { label: 'Conference Gate', value: 'conference_gate' },
  { label: 'Entertainment Gate', value: 'entertainment_gate' },
]

export const PARTICIPANT_OPTIONS = [
  { label: 'Volunteer', value: 'volunteer' },
  { label: 'Speaker', value: 'speaker' },
  { label: 'Sponsor', value: 'sponsor' },
  { label: 'Organizing Team', value: 'organizer' },
  { label: 'Media', value: 'media' },
]

export const MAP_HEIGHT = '400px'

export const INITIAL_MAX_FILE_LIMIT = 1
export const INITIAL_MAX_FILE_SIZE = 1024 * 1024 * 2 // 2MB in bytes
export const INITIAL_FILE_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_WITH_TIME = 'YYYY-MM-DD HH:mm'
export const DATE_FORMAT_WITH_TIME_AND_SECONDS = 'YYYY-MM-DD HH:mm:ss'

export const NOTIFICATION_PLACEMENT = 'bottomRight'

// API Methods
export const DELETE = 'DELETE'
export const GET = 'GET'
export const POST = 'POST'
export const PATCH = 'PATCH'
export const PUT = 'PUT'

// Pending Actions
export const PENDING_ACTIONS = {
  switch: 'switch',
  edit: 'edit',
  view: 'view',
  delete: 'delete',
  patch: 'patch',
  print: 'print',
  participants: 'participants',
  users: 'users',
  view_payment: 'view-payment',
  view_attachments: 'view-attachments',
  download_qrcode: 'download-qrcode',
}

// country list
export const COUNTRIES_LIST = [
	{
		name_en: 'Afghanistan',
		name_ar: 'أفغانستان',
		name_ku: 'ئەفغانستان',
		country_phone_code: 93,
		country_code: 'AF',
	},
	{
		name_en: 'Albania',
		name_ar: 'ألبانيا',
		name_ku: 'ئەلبانیا',
		country_phone_code: 355,
		country_code: 'AL',
	},
	{
		name_en: 'Algeria',
		name_ar: 'الجزائر',
		name_ku: 'ئەلجزائیر',
		country_phone_code: 213,
		country_code: 'DZ',
	},
	{
		name_en: 'Andorra',
		name_ar: 'أندورا',
		name_ku: 'ئاندۆرا',
		country_phone_code: 376,
		country_code: 'AD',
	},
	{
		name_en: 'Angola',
		name_ar: 'أنغولا',
		name_ku: 'ئەنغۆلا',
		country_phone_code: 244,
		country_code: 'AO',
	},
	{
		name_en: 'Antigua and Barbuda',
		name_ar: 'أنتيغوا وبربودا',
		name_ku: 'ئەنتیگوا و بەرەبودا',
		country_phone_code: 1268,
		country_code: 'AG',
	},
	{
		name_en: 'Argentina',
		name_ar: 'الأرجنتين',
		name_ku: 'ئەرژەنتین',
		country_phone_code: 54,
		country_code: 'AR',
	},
	{
		name_en: 'Armenia',
		name_ar: 'أرمينيا',
		name_ku: 'ئەرمیەنا',
		country_phone_code: 374,
		country_code: 'AM',
	},
	{
		name_en: 'Australia',
		name_ar: 'أستراليا',
		name_ku: 'ئۆسترالیا',
		country_phone_code: 61,
		country_code: 'AU',
	},
	{
		name_en: 'Austria',
		name_ar: 'النمسا',
		name_ku: 'ئەنمسا',
		country_phone_code: 43,
		country_code: 'AT',
	},
	{
		name_en: 'Azerbaijan',
		name_ar: 'أذربيجان',
		name_ku: 'ئەذربەجان',
		country_phone_code: 994,
		country_code: 'AZ',
	},
	{
		name_en: 'Bahamas',
		name_ar: 'الباهاماس',
		name_ku: 'بەهاماس',
		country_phone_code: 1242,
		country_code: 'BS',
	},
	{
		name_en: 'Bahrain',
		name_ar: 'البحرين',
		name_ku: 'بەحرەین',
		country_phone_code: 973,
		country_code: 'BH',
	},
	{
		name_en: 'Bangladesh',
		name_ar: 'بنغلاديش',
		name_ku: 'بەنگلادیش',
		country_phone_code: 880,
		country_code: 'BD',
	},
	{
		name_en: 'Barbados',
		name_ar: 'بربادوس',
		name_ku: 'بەربادۆس',
		country_phone_code: 1246,
		country_code: 'BB',
	},
	{
		name_en: 'Belarus',
		name_ar: 'روسيا البيضاء',
		name_ku: 'ڕوسیا بێضا',
		country_phone_code: 375,
		country_code: 'BY',
	},
	{
		name_en: 'Belgium',
		name_ar: 'بلجيكا',
		name_ku: 'بەلجیکا',
		country_phone_code: 32,
		country_code: 'BE',
	},
	{
		name_en: 'Belize',
		name_ar: 'بليز',
		name_ku: 'بەلیز',
		country_phone_code: 501,
		country_code: 'BZ',
	},
	{
		name_en: 'Benin',
		name_ar: 'بنين',
		name_ku: 'بەنین',
		country_phone_code: 229,
		country_code: 'BJ',
	},
	{
		name_en: 'Bhutan',
		name_ar: 'بوتان',
		name_ku: 'بۆتان',
		country_phone_code: 975,
		country_code: 'BT',
	},
	{
		name_en: 'Bolivia',
		name_ar: 'بوليفيا',
		name_ku: 'بۆلیڤیا',
		country_phone_code: 591,
		country_code: 'BO',
	},
	{
		name_en: 'Bosnia and Herzegovina',
		name_ar: 'البوسنة والهرسك',
		name_ku: 'بۆسنیا و هەرسك',
		country_phone_code: 387,
		country_code: 'BA',
	},
	{
		name_en: 'Botswana',
		name_ar: 'بوتسوانا',
		name_ku: 'بۆتسوانا',
		country_phone_code: 267,
		country_code: 'BW',
	},
	{
		name_en: 'Brazil',
		name_ar: 'البرازيل',
		name_ku: 'بەرازیل',
		country_phone_code: 55,
		country_code: 'BR',
	},
	{
		name_en: 'Brunei',
		name_ar: 'بروناي',
		name_ku: 'بڕونای',
		country_phone_code: 673,
		country_code: 'BN',
	},
	{
		name_en: 'Bulgaria',
		name_ar: 'بلغاريا',
		name_ku: 'بلغاریا',
		country_phone_code: 359,
		country_code: 'BG',
	},
	{
		name_en: 'Burkina Faso',
		name_ar: 'بوركينا فاسو',
		name_ku: 'بۇركینا فاسۆ',
		country_phone_code: 226,
		country_code: 'BF',
	},
	{
		name_en: 'Burundi',
		name_ar: 'بوروندي',
		name_ku: 'بۇروندی',
		country_phone_code: 257,
		country_code: 'BI',
	},
	{
		name_en: 'Cabo Verde',
		name_ar: 'كابو فيردي',
		name_ku: 'كابۆ ڤێردی',
		country_phone_code: 238,
		country_code: 'CV',
	},
	{
		name_en: 'Cambodia',
		name_ar: 'كمبوديا',
		name_ku: 'كەمبودیا',
		country_phone_code: 855,
		country_code: 'KH',
	},
	{
		name_en: 'Cameroon',
		name_ar: 'الكاميرون',
		name_ku: 'كامێرۆن',
		country_phone_code: 237,
		country_code: 'CM',
	},
	{
		name_en: 'Canada',
		name_ar: 'كندا',
		name_ku: 'كانادا',
		country_phone_code: 1,
		country_code: 'CA',
	},
	{
		name_en: 'Central African Republic',
		name_ar: 'جمهورية أفريقيا الوسطى',
		name_ku: 'كۆماری ئەفریقا ناوەڕاست',
		country_phone_code: 236,
		country_code: 'CF',
	},
	{
		name_en: 'Chad',
		name_ar: 'تشاد',
		name_ku: 'چاد',
		country_phone_code: 235,
		country_code: 'TD',
	},
	{
		name_en: 'Chile',
		name_ar: 'تشيلي',
		name_ku: 'چیلی',
		country_phone_code: 56,
		country_code: 'CL',
	},
	{
		name_en: 'China',
		name_ar: 'الصين',
		name_ku: 'چین',
		country_phone_code: 86,
		country_code: 'CN',
	},
	{
		name_en: 'Colombia',
		name_ar: 'كولومبيا',
		name_ku: 'كولۆمبیا',
		country_phone_code: 57,
		country_code: 'CO',
	},
	{
		name_en: 'Comoros',
		name_ar: 'جزر القمر',
		name_ku: 'جەزایر كۆمۆر',
		country_phone_code: 269,
		country_code: 'KM',
	},
	{
		name_en: 'Congo, Democratic Republic of the',
		name_ar: 'جمهورية الكونغو الديمقراطية',
		name_ku: 'كۆماری دێموكراتیی كۆنگۆ',
		country_phone_code: 243,
		country_code: 'CD',
	},
	{
		name_en: 'Congo, Republic of the',
		name_ar: 'جمهورية الكونغو',
		name_ku: 'كۆماری كۆنگۆ',
		country_phone_code: 242,
		country_code: 'CG',
	},
	{
		name_en: 'Costa Rica',
		name_ar: 'كوستاريكا',
		name_ku: 'كوستاریكا',
		country_phone_code: 506,
		country_code: 'CR',
	},
	{
		name_en: 'Croatia',
		name_ar: 'كرواتيا',
		name_ku: 'كرواتیا',
		country_phone_code: 385,
		country_code: 'HR',
	},
	{
		name_en: 'Cuba',
		name_ar: 'كوبا',
		name_ku: 'كوبا',
		country_phone_code: 53,
		country_code: 'CU',
	},
	{
		name_en: 'Cyprus',
		name_ar: 'قبرص',
		name_ku: 'قوبرس',
		country_phone_code: 357,
		country_code: 'CY',
	},
	{
		name_en: 'Czech Republic',
		name_ar: 'جمهورية التشيك',
		name_ku: 'كۆماری چیک',
		country_phone_code: 420,
		country_code: 'CZ',
	},
	{
		name_en: 'Denmark',
		name_ar: 'الدنمارك',
		name_ku: 'دانمارك',
		country_phone_code: 45,
		country_code: 'DK',
	},
	{
		name_en: 'Djibouti',
		name_ar: 'جيبوتي',
		name_ku: 'جیبوتی',
		country_phone_code: 253,
		country_code: 'DJ',
	},
	{
		name_en: 'Dominica',
		name_ar: 'دومينيكا',
		name_ku: 'دومینكا',
		country_phone_code: 1767,
		country_code: 'DM',
	},
	{
		name_en: 'Dominican Republic',
		name_ar: 'جمهورية الدومينيكان',
		name_ku: 'كۆماری دومینیكان',
		country_phone_code: 1809,
		country_code: 'DO',
	},
	{
		name_en: 'Ecuador',
		name_ar: 'الإكوادور',
		name_ku: 'ئەكووادۆر',
		country_phone_code: 593,
		country_code: 'EC',
	},
	{
		name_en: 'Egypt',
		name_ar: 'مصر',
		name_ku: 'مصر',
		country_phone_code: 20,
		country_code: 'EG',
	},
	{
		name_en: 'El Salvador',
		name_ar: 'السلفادور',
		name_ku: 'ئەل سەلڤادۆر',
		country_phone_code: 503,
		country_code: 'SV',
	},
	{
		name_en: 'Equatorial Guinea',
		name_ar: 'غينيا الاستوائية',
		name_ku: 'گینیا یەكسان',
		country_phone_code: 240,
		country_code: 'GQ',
	},
	{
		name_en: 'Eritrea',
		name_ar: 'إريتريا',
		name_ku: 'ئەریتریا',
		country_phone_code: 291,
		country_code: 'ER',
	},
	{
		name_en: 'Estonia',
		name_ar: 'إستونيا',
		name_ku: 'ئەستۆنیا',
		country_phone_code: 372,
		country_code: 'EE',
	},
	{
		name_en: 'Eswatini',
		name_ar: 'إسواتيني',
		name_ku: 'ئەسواتینی',
		country_phone_code: 268,
		country_code: 'SZ',
	},
	{
		name_en: 'Ethiopia',
		name_ar: 'إثيوبيا',
		name_ku: 'ئەثیۆپیا',
		country_phone_code: 251,
		country_code: 'ET',
	},
	{
		name_en: 'Fiji',
		name_ar: 'فيجي',
		name_ku: 'فیجی',
		country_phone_code: 679,
		country_code: 'FJ',
	},
	{
		name_en: 'Finland',
		name_ar: 'فنلندا',
		name_ku: 'فنلاندا',
		country_phone_code: 358,
		country_code: 'FI',
	},
	{
		name_en: 'France',
		name_ar: 'فرنسا',
		name_ku: 'فەرەنسا',
		country_phone_code: 33,
		country_code: 'FR',
	},
	{
		name_en: 'Gabon',
		name_ar: 'الغابون',
		name_ku: 'گابۆن',
		country_phone_code: 241,
		country_code: 'GA',
	},
	{
		name_en: 'Gambia',
		name_ar: 'غامبيا',
		name_ku: 'گامبیا',
		country_phone_code: 220,
		country_code: 'GM',
	},
	{
		name_en: 'Georgia',
		name_ar: 'جورجيا',
		name_ku: 'جۆرجیا',
		country_phone_code: 995,
		country_code: 'GE',
	},
	{
		name_en: 'Germany',
		name_ar: 'ألمانيا',
		name_ku: 'ئەڵمانیا',
		country_phone_code: 49,
		country_code: 'DE',
	},
	{
		name_en: 'Ghana',
		name_ar: 'غانا',
		name_ku: 'غانا',
		country_phone_code: 233,
		country_code: 'GH',
	},
	{
		name_en: 'Greece',
		name_ar: 'اليونان',
		name_ku: 'یۆنان',
		country_phone_code: 30,
		country_code: 'GR',
	},
	{
		name_en: 'Grenada',
		name_ar: 'غرينادا',
		name_ku: 'گرینادا',
		country_phone_code: 1473,
		country_code: 'GD',
	},
	{
		name_en: 'Guatemala',
		name_ar: 'غواتيمالا',
		name_ku: 'گواتیمالا',
		country_phone_code: 502,
		country_code: 'GT',
	},
	{
		name_en: 'Guinea',
		name_ar: 'غينيا',
		name_ku: 'گینیا',
		country_phone_code: 224,
		country_code: 'GN',
	},
	{
		name_en: 'Guinea-Bissau',
		name_ar: 'غينيا بيساو',
		name_ku: 'گینیا بیساو',
		country_phone_code: 245,
		country_code: 'GW',
	},
	{
		name_en: 'Guyana',
		name_ar: 'غيانا',
		name_ku: 'گایانا',
		country_phone_code: 592,
		country_code: 'GY',
	},
	{
		name_en: 'Haiti',
		name_ar: 'هايتي',
		name_ku: 'هایەتی',
		country_phone_code: 509,
		country_code: 'HT',
	},
	{
		name_en: 'Honduras',
		name_ar: 'هندوراس',
		name_ku: 'هەندوراس',
		country_phone_code: 504,
		country_code: 'HN',
	},
	{
		name_en: 'Hungary',
		name_ar: 'هنغاريا',
		name_ku: 'هنغاریا',
		country_phone_code: 36,
		country_code: 'HU',
	},
	{
		name_en: 'Iceland',
		name_ar: 'آيسلندا',
		name_ku: 'ئایسلەند',
		country_phone_code: 354,
		country_code: 'IS',
	},
	{
		name_en: 'India',
		name_ar: 'الهند',
		name_ku: 'هند',
		country_phone_code: 91,
		country_code: 'IN',
	},
	{
		name_en: 'Indonesia',
		name_ar: 'إندونيسيا',
		name_ku: 'ئێندۆنیزیا',
		country_phone_code: 62,
		country_code: 'ID',
	},
	{
		name_en: 'Iran',
		name_ar: 'إيران',
		name_ku: 'ئیراڤن',
		country_phone_code: 98,
		country_code: 'IR',
	},
	{
		name_en: 'Iraq',
		name_ar: 'العراق',
		name_ku: 'عێراق',
		country_phone_code: 964,
		country_code: 'IQ',
	},
	{
		name_en: 'Ireland',
		name_ar: 'أيرلندا',
		name_ku: 'ئیرلەندا',
		country_phone_code: 353,
		country_code: 'IE',
	},
	{
		name_en: 'Israel',
		name_ar: 'إسرائيل',
		name_ku: 'ئیسرائیل',
		country_phone_code: 972,
		country_code: 'IL',
	},
	{
		name_en: 'Italy',
		name_ar: 'إيطاليا',
		name_ku: 'ئیطالیا',
		country_phone_code: 39,
		country_code: 'IT',
	},
	{
		name_en: 'Jamaica',
		name_ar: 'جامايكا',
		name_ku: 'جامایكا',
		country_phone_code: 1876,
		country_code: 'JM',
	},
	{
		name_en: 'Japan',
		name_ar: 'اليابان',
		name_ku: 'یابان',
		country_phone_code: 81,
		country_code: 'JP',
	},
	{
		name_en: 'Jordan',
		name_ar: 'الأردن',
		name_ku: 'ئوردن',
		country_phone_code: 962,
		country_code: 'JO',
	},
	{
		name_en: 'Kazakhstan',
		name_ar: 'كازاخستان',
		name_ku: 'كازاخستان',
		country_phone_code: 7,
		country_code: 'KZ',
	},
	{
		name_en: 'Kenya',
		name_ar: 'كينيا',
		name_ku: 'كینیا',
		country_phone_code: 254,
		country_code: 'KE',
	},
	{
		name_en: 'Kiribati',
		name_ar: 'كيريباتي',
		name_ku: 'كیراباتی',
		country_phone_code: 686,
		country_code: 'KI',
	},
	{
		name_en: 'Korea, North',
		name_ar: 'كوريا الشمالية',
		name_ku: 'كۆریای باكوور',
		country_phone_code: 850,
		country_code: 'KP',
	},
	{
		name_en: 'Korea, South',
		name_ar: 'كوريا الجنوبية',
		name_ku: 'كۆریای باشوور',
		country_phone_code: 82,
		country_code: 'KR',
	},
	{
		name_en: 'Kuwait',
		name_ar: 'الكويت',
		name_ku: 'كوەیت',
		country_phone_code: 965,
		country_code: 'KW',
	},
	{
		name_en: 'Kyrgyzstan',
		name_ar: 'قيرغيزستان',
		name_ku: 'قیرغیزستان',
		country_phone_code: 996,
		country_code: 'KG',
	},
	{
		name_en: 'Laos',
		name_ar: 'لاوس',
		name_ku: 'لاوس',
		country_phone_code: 856,
		country_code: 'LA',
	},
	{
		name_en: 'Latvia',
		name_ar: 'لاتفيا',
		name_ku: 'لاتڤیا',
		country_phone_code: 371,
		country_code: 'LV',
	},
	{
		name_en: 'Lebanon',
		name_ar: 'لبنان',
		name_ku: 'لوبنان',
		country_phone_code: 961,
		country_code: 'LB',
	},
	{
		name_en: 'Lesotho',
		name_ar: 'ليسوتو',
		name_ku: 'لیسۆتو',
		country_phone_code: 266,
		country_code: 'LS',
	},
	{
		name_en: 'Liberia',
		name_ar: 'ليبيريا',
		name_ku: 'لیبێریا',
		country_phone_code: 231,
		country_code: 'LR',
	},
	{
		name_en: 'Libya',
		name_ar: 'ليبيا',
		name_ku: 'لیبیا',
		country_phone_code: 218,
		country_code: 'LY',
	},
	{
		name_en: 'Liechtenstein',
		name_ar: 'ليختنشتاين',
		name_ku: 'لیختنشتاین',
		country_phone_code: 423,
		country_code: 'LI',
	},
	{
		name_en: 'Lithuania',
		name_ar: 'ليتوانيا',
		name_ku: 'لیتۆڤانیا',
		country_phone_code: 370,
		country_code: 'LT',
	},
	{
		name_en: 'Luxembourg',
		name_ar: 'لوكسمبورغ',
		name_ku: 'لوكسەمبۆرگ',
		country_phone_code: 352,
		country_code: 'LU',
	},
	{
		name_en: 'Madagascar',
		name_ar: 'مدغشقر',
		name_ku: 'مەداگاسكار',
		country_phone_code: 261,
		country_code: 'MG',
	},
	{
		name_en: 'Malawi',
		name_ar: 'مالاوي',
		name_ku: 'مالاوی',
		country_phone_code: 265,
		country_code: 'MW',
	},
	{
		name_en: 'Malaysia',
		name_ar: 'ماليزيا',
		name_ku: 'مالیزیا',
		country_phone_code: 60,
		country_code: 'MY',
	},
	{
		name_en: 'Maldives',
		name_ar: 'جزر المالديف',
		name_ku: 'گەزەری مالىڤ',
		country_phone_code: 960,
		country_code: 'MV',
	},
	{
		name_en: 'Mali',
		name_ar: 'مالي',
		name_ku: 'مالی',
		country_phone_code: 223,
		country_code: 'ML',
	},
	{
		name_en: 'Malta',
		name_ar: 'مالطا',
		name_ku: 'مالتا',
		country_phone_code: 356,
		country_code: 'MT',
	},
	{
		name_en: 'Marshall Islands',
		name_ar: 'جزر مارشال',
		name_ku: 'گەزەری مارشال',
		country_phone_code: 692,
		country_code: 'MH',
	},
	{
		name_en: 'Mauritania',
		name_ar: 'موريتانيا',
		name_ku: 'مۆریتانیا',
		country_phone_code: 222,
		country_code: 'MR',
	},
	{
		name_en: 'Mauritius',
		name_ar: 'موريشيوس',
		name_ku: 'مۆریشۆس',
		country_phone_code: 230,
		country_code: 'MU',
	},
	{
		name_en: 'Mexico',
		name_ar: 'المكسيك',
		name_ku: 'مێكسیكو',
		country_phone_code: 52,
		country_code: 'MX',
	},
	{
		name_en: 'Micronesia',
		name_ar: 'ميكرونيزيا',
		name_ku: 'میكرۆنێزیا',
		country_phone_code: 691,
		country_code: 'FM',
	},
	{
		name_en: 'Moldova',
		name_ar: 'مولدوفا',
		name_ku: 'مۆلدۆڤا',
		country_phone_code: 373,
		country_code: 'MD',
	},
	{
		name_en: 'Monaco',
		name_ar: 'موناكو',
		name_ku: 'مۆناكو',
		country_phone_code: 377,
		country_code: 'MC',
	},
	{
		name_en: 'Mongolia',
		name_ar: 'منغوليا',
		name_ku: 'مەنگۆلیا',
		country_phone_code: 976,
		country_code: 'MN',
	},
	{
		name_en: 'Montenegro',
		name_ar: 'الجبل الأسود',
		name_ku: 'ئەلجەبەل ئەسوود',
		country_phone_code: 382,
		country_code: 'ME',
	},
	{
		name_en: 'Morocco',
		name_ar: 'المغرب',
		name_ku: 'مارۆكو',
		country_phone_code: 212,
		country_code: 'MA',
	},
	{
		name_en: 'Mozambique',
		name_ar: 'موزمبيق',
		name_ku: 'مۆزامبیك',
		country_phone_code: 258,
		country_code: 'MZ',
	},
	{
		name_en: 'Myanmar',
		name_ar: 'ميانمار',
		name_ku: 'میانمار',
		country_phone_code: 95,
		country_code: 'MM',
	},
	{
		name_en: 'Namibia',
		name_ar: 'ناميبيا',
		name_ku: 'نامیبیا',
		country_phone_code: 264,
		country_code: 'NA',
	},
	{
		name_en: 'Nauru',
		name_ar: 'ناورو',
		name_ku: 'نائورە',
		country_phone_code: 674,
		country_code: 'NR',
	},
	{
		name_en: 'Nepal',
		name_ar: 'نيبال',
		name_ku: 'نیپال',
		country_phone_code: 977,
		country_code: 'NP',
	},
	{
		name_en: 'Netherlands',
		name_ar: 'هولندا',
		name_ku: 'هۆڵەندا',
		country_phone_code: 31,
		country_code: 'NL',
	},
	{
		name_en: 'New Zealand',
		name_ar: 'نيوزيلندا',
		name_ku: 'نیو زیلاند',
		country_phone_code: 64,
		country_code: 'NZ',
	},
	{
		name_en: 'Nicaragua',
		name_ar: 'نيكاراغوا',
		name_ku: 'نیكاراگوا',
		country_phone_code: 505,
		country_code: 'NI',
	},
	{
		name_en: 'Niger',
		name_ar: 'النيجر',
		name_ku: 'نیجر',
		country_phone_code: 227,
		country_code: 'NE',
	},
	{
		name_en: 'Nigeria',
		name_ar: 'نيجيريا',
		name_ku: 'نیجیریا',
		country_phone_code: 234,
		country_code: 'NG',
	},
	{
		name_en: 'North Macedonia',
		name_ar: 'مقدونيا الشمالية',
		name_ku: 'مقدونیا باكوور',
		country_phone_code: 389,
		country_code: 'MK',
	},
	{
		name_en: 'Norway',
		name_ar: 'النرويج',
		name_ku: 'نەرویژ',
		country_phone_code: 47,
		country_code: 'NO',
	},
	{
		name_en: 'Oman',
		name_ar: 'عمان',
		name_ku: 'عومان',
		country_phone_code: 968,
		country_code: 'OM',
	},
	{
		name_en: 'Pakistan',
		name_ar: 'باكستان',
		name_ku: 'پاكاستان',
		country_phone_code: 92,
		country_code: 'PK',
	},
	{
		name_en: 'Palau',
		name_ar: 'بالاو',
		name_ku: 'پالاۆ',
		country_phone_code: 680,
		country_code: 'PW',
	},
	{
		name_en: 'Palestine',
		name_ar: 'فلسطين',
		name_ku: 'فلسطین',
		country_phone_code: 970,
		country_code: 'PS',
	},
	{
		name_en: 'Panama',
		name_ar: 'بنما',
		name_ku: 'پەناما',
		country_phone_code: 507,
		country_code: 'PA',
	},
	{
		name_en: 'Papua New Guinea',
		name_ar: 'بابوا غينيا الجديدة',
		name_ku: 'بابوا گینیا نوێ',
		country_phone_code: 675,
		country_code: 'PG',
	},
	{
		name_en: 'Paraguay',
		name_ar: 'باراغواي',
		name_ku: 'پاراكۆای',
		country_phone_code: 595,
		country_code: 'PY',
	},
	{
		name_en: 'Peru',
		name_ar: 'بيرو',
		name_ku: 'پێرو',
		country_phone_code: 51,
		country_code: 'PE',
	},
	{
		name_en: 'Philippines',
		name_ar: 'الفلبين',
		name_ku: 'فلیپین',
		country_phone_code: 63,
		country_code: 'PH',
	},
	{
		name_en: 'Poland',
		name_ar: 'بولندا',
		name_ku: 'پۆلندا',
		country_phone_code: 48,
		country_code: 'PL',
	},
	{
		name_en: 'Portugal',
		name_ar: 'البرتغال',
		name_ku: 'پورتوگال',
		country_phone_code: 351,
		country_code: 'PT',
	},
	{
		name_en: 'Qatar',
		name_ar: 'قطر',
		name_ku: 'قەتەر',
		country_phone_code: 974,
		country_code: 'QA',
	},
	{
		name_en: 'Romania',
		name_ar: 'رومانيا',
		name_ku: 'ڕومانیا',
		country_phone_code: 40,
		country_code: 'RO',
	},
	{
		name_en: 'Russia',
		name_ar: 'روسيا',
		name_ku: 'ڕوسیا',
		country_phone_code: 7,
		country_code: 'RU',
	},
	{
		name_en: 'Rwanda',
		name_ar: 'رواندا',
		name_ku: 'ڕواندا',
		country_phone_code: 250,
		country_code: 'RW',
	},
	{
		name_en: 'Saint Kitts and Nevis',
		name_ar: 'سانت كيتس ونيفيس',
		name_ku: 'سانت كیتس و نیڤیس',
		country_phone_code: 1869,
		country_code: 'KN',
	},
	{
		name_en: 'Saint Lucia',
		name_ar: 'سانت لوسيا',
		name_ku: 'سانت لوسیا',
		country_phone_code: 1758,
		country_code: 'LC',
	},
	{
		name_en: 'Saint Vincent and the Grenadines',
		name_ar: 'سانت فنسنت والغرينادين',
		name_ku: 'سانت ڤینسنت و گرێنادینس',
		country_phone_code: 1784,
		country_code: 'VC',
	},
	{
		name_en: 'Samoa',
		name_ar: 'ساموا',
		name_ku: 'ساموا',
		country_phone_code: 685,
		country_code: 'WS',
	},
	{
		name_en: 'San Marino',
		name_ar: 'سان مارينو',
		name_ku: 'سان مارینو',
		country_phone_code: 378,
		country_code: 'SM',
	},
	{
		name_en: 'Sao Tome and Principe',
		name_ar: 'ساو تومي وبرينسيب',
		name_ku: 'ساو تۆمی و پرینسیپ',
		country_phone_code: 239,
		country_code: 'ST',
	},
	{
		name_en: 'Saudi Arabia',
		name_ar: 'المملكة العربية السعودية',
		name_ku: 'بەریا ئەرەبییا سەعوودی',
		country_phone_code: 966,
		country_code: 'SA',
	},
	{
		name_en: 'Senegal',
		name_ar: 'السنغال',
		name_ku: 'سینیگال',
		country_phone_code: 221,
		country_code: 'SN',
	},
	{
		name_en: 'Serbia',
		name_ar: 'صربيا',
		name_ku: 'سربیا',
		country_phone_code: 381,
		country_code: 'RS',
	},
	{
		name_en: 'Seychelles',
		name_ar: 'سيشيل',
		name_ku: 'سیشێل',
		country_phone_code: 248,
		country_code: 'SC',
	},
	{
		name_en: 'Sierra Leone',
		name_ar: 'سيراليون',
		name_ku: 'سیرا لیۆن',
		country_phone_code: 232,
		country_code: 'SL',
	},
	{
		name_en: 'Singapore',
		name_ar: 'سنغافورة',
		name_ku: 'سینگاپور',
		country_phone_code: 65,
		country_code: 'SG',
	},
	{
		name_en: 'Slovakia',
		name_ar: 'سلوفاكيا',
		name_ku: 'سلۆفاكیا',
		country_phone_code: 421,
		country_code: 'SK',
	},
	{
		name_en: 'Slovenia',
		name_ar: 'سلوفينيا',
		name_ku: 'سلۆڤینیا',
		country_phone_code: 386,
		country_code: 'SI',
	},
	{
		name_en: 'Solomon Islands',
		name_ar: 'جزر سليمان',
		name_ku: 'گەزەری سلێمان',
		country_phone_code: 677,
		country_code: 'SB',
	},
	{
		name_en: 'Somalia',
		name_ar: 'الصومال',
		name_ku: 'سۆمالیا',
		country_phone_code: 252,
		country_code: 'SO',
	},
	{
		name_en: 'South Africa',
		name_ar: 'جنوب أفريقيا',
		name_ku: 'ئەفریقا باشور',
		country_phone_code: 27,
		country_code: 'ZA',
	},
	{
		name_en: 'South Sudan',
		name_ar: 'جنوب السودان',
		name_ku: 'باشوری سوودان',
		country_phone_code: 211,
		country_code: 'SS',
	},
	{
		name_en: 'Spain',
		name_ar: 'إسبانيا',
		name_ku: 'ئیسپانیا',
		country_phone_code: 34,
		country_code: 'ES',
	},
	{
		name_en: 'Sri Lanka',
		name_ar: 'سريلانكا',
		name_ku: 'سریلانكا',
		country_phone_code: 94,
		country_code: 'LK',
	},
	{
		name_en: 'Sudan',
		name_ar: 'السودان',
		name_ku: 'سوودان',
		country_phone_code: 249,
		country_code: 'SD',
	},
	{
		name_en: 'Suriname',
		name_ar: 'سورينام',
		name_ku: 'سورینام',
		country_phone_code: 597,
		country_code: 'SR',
	},
	{
		name_en: 'Sweden',
		name_ar: 'السويد',
		name_ku: 'سوێد',
		country_phone_code: 46,
		country_code: 'SE',
	},
	{
		name_en: 'Switzerland',
		name_ar: 'سويسرا',
		name_ku: 'سوید',
		country_phone_code: 41,
		country_code: 'CH',
	},
	{
		name_en: 'Syria',
		name_ar: 'سوريا',
		name_ku: 'سوریا',
		country_phone_code: 963,
		country_code: 'SY',
	},
	{
		name_en: 'Taiwan',
		name_ar: 'تايوان',
		name_ku: 'تایوان',
		country_phone_code: 886,
		country_code: 'TW',
	},
	{
		name_en: 'Tajikistan',
		name_ar: 'طاجيكستان',
		name_ku: 'تاجیکستان',
		country_phone_code: 992,
		country_code: 'TJ',
	},
	{
		name_en: 'Tanzania',
		name_ar: 'تنزانيا',
		name_ku: 'تەنزانیا',
		country_phone_code: 255,
		country_code: 'TZ',
	},
	{
		name_en: 'Thailand',
		name_ar: 'تايلاند',
		name_ku: 'تایلاند',
		country_phone_code: 66,
		country_code: 'TH',
	},
	{
		name_en: 'Timor-Leste',
		name_ar: 'تيمور الشرقية',
		name_ku: 'تیمور',
		country_phone_code: 670,
		country_code: 'TL',
	},
	{
		name_en: 'Togo',
		name_ar: 'توغو',
		name_ku: 'تۆگۆ',
		country_phone_code: 228,
		country_code: 'TG',
	},
	{
		name_en: 'Tonga',
		name_ar: 'تونغا',
		name_ku: 'تۆنگا',
		country_phone_code: 676,
		country_code: 'TO',
	},
	{
		name_en: 'Trinidad and Tobago',
		name_ar: 'ترينيداد وتوباغو',
		name_ku: 'ترینیداد و تۆباگو',
		country_phone_code: 1868,
		country_code: 'TT',
	},
	{
		name_en: 'Tunisia',
		name_ar: 'تونس',
		name_ku: 'تونیس',
		country_phone_code: 216,
		country_code: 'TN',
	},
	{
		name_en: 'Turkey',
		name_ar: 'تركيا',
		name_ku: 'توركیا',
		country_phone_code: 90,
		country_code: 'TR',
	},
	{
		name_en: 'Turkmenistan',
		name_ar: 'تركمانستان',
		name_ku: 'توركمەنستان',
		country_phone_code: 993,
		country_code: 'TM',
	},
	{
		name_en: 'Tuvalu',
		name_ar: 'توفالو',
		name_ku: 'تۆڤالو',
		country_phone_code: 688,
		country_code: 'TV',
	},
	{
		name_en: 'Uganda',
		name_ar: 'أوغندا',
		name_ku: 'ئەوغندا',
		country_phone_code: 256,
		country_code: 'UG',
	},
	{
		name_en: 'Ukraine',
		name_ar: 'أوكرانيا',
		name_ku: 'ئەوكرانیا',
		country_phone_code: 380,
		country_code: 'UA',
	},
	{
		name_en: 'United Arab Emirates',
		name_ar: 'الإمارات العربية المتحدة',
		name_ku: 'بەریا ئەرەبییا یەكنێی',
		country_phone_code: 971,
		country_code: 'AE',
	},
	{
		name_en: 'United Kingdom',
		name_ar: 'المملكة المتحدة',
		name_ku: 'بەریا یەكنێی',
		country_phone_code: 44,
		country_code: 'GB',
	},
	{
		name_en: 'United States',
		name_ar: 'الولايات المتحدة',
		name_ku: 'ئەوڵاتێن یەكنێی',
		country_phone_code: 1,
		country_code: 'US',
	},
	{
		name_en: 'Uruguay',
		name_ar: 'أوروغواي',
		name_ku: 'ئوركوا',
		country_phone_code: 598,
		country_code: 'UY',
	},
	{
		name_en: 'Uzbekistan',
		name_ar: 'أوزبكستان',
		name_ku: 'ئوزبەکستان',
		country_phone_code: 998,
		country_code: 'UZ',
	},
	{
		name_en: 'Vanuatu',
		name_ar: 'فانواتو',
		name_ku: 'ڤانوواتوو',
		country_phone_code: 678,
		country_code: 'VU',
	},
	{
		name_en: 'Vatican City',
		name_ar: 'مدينة الفاتيكان',
		name_ku: 'فاتیكان',
		country_phone_code: 39,
		country_code: 'VA',
	},
	{
		name_en: 'Venezuela',
		name_ar: 'فنزويلا',
		name_ku: 'ڤەنزوێلا',
		country_phone_code: 58,
		country_code: 'VE',
	},
	{
		name_en: 'Vietnam',
		name_ar: 'فيتنام',
		name_ku: 'ڤیەتنام',
		country_phone_code: 84,
		country_code: 'VN',
	},
	{
		name_en: 'Yemen',
		name_ar: 'اليمن',
		name_ku: 'یەمەن',
		country_phone_code: 967,
		country_code: 'YE',
	},
	{
		name_en: 'Zambia',
		name_ar: 'زامبيا',
		name_ku: 'زامبیا',
		country_phone_code: 260,
		country_code: 'ZM',
	},
	{
		name_en: 'Zimbabwe',
		name_ar: 'زيمبابوي',
		name_ku: 'زیمبابوە',
		country_phone_code: 263,
		country_code: 'ZW',
	},
];

// Token Name
export const TOKEN_NAME = 'hitex-token'

export const COUNTRY_CODE = '+964'

export const BASE64_IMAGE_FALLBACK =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=='
